import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

// hooks.
import useCopyToClipboard from 'app/client/utilities/hooks/useCopytoClipboard';

// styled.
import * as S from './styled';

const CopyField = ({ name, type, content, children }) => {
  const { t } = useTranslation();
  const [isCopied, handleCopy] = useCopyToClipboard(1500);
  const id = `copy-${name}`;

  return (
    <S.Field>
      <S.Content>
        {children ??
          content.split('\n').map((item) => (
            <React.Fragment key={item}>
              {item}
              <br />
            </React.Fragment>
          ))}
      </S.Content>
      <S.CopyButton type="button" id={id} copied={isCopied} onClick={() => handleCopy(content)}>
        <FontAwesomeIcon icon={isCopied ? byPrefixAndName.fal.check : byPrefixAndName.fal.copy} />
      </S.CopyButton>
      <Tooltip anchorSelect={`#${id}`} positionStrategy="top" place="top" clickable>
        {t(isCopied ? 'core:common.copied' : 'core:common.copy', {
          type: type || t('core:common.value'),
        })}
      </Tooltip>
    </S.Field>
  );
};

CopyField.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  content: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default CopyField;
